
import { defineComponent, PropType } from 'vue';
import type { User } from '@white-label-types/parking-shared';

// Components
import ToggleContent from '../toggle-content/toggle-content.vue';

export default defineComponent({
  name: 'BTicketTripDetails',

  components: {
    ToggleContent,
  },

  props: {
    user: {
      type: Object as PropType<User>,
      required: true,
    },
  },
});
